var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Tooltip } from 'modules/Tooltip';
import { useIsTruncated } from 'modules/hooks/useIsTruncated';
import { Falcon } from 'modules/macro';
import { ItemContainer, StyledTypography } from './styled';
export function Breadcrumb(props) {
    const { children, as } = props, restProps = __rest(props, ["children", "as"]);
    const { ref, isTruncated } = useIsTruncated();
    return (<ItemContainer>
      <Tooltip title={children} disabled={!isTruncated}>
        <StyledTypography ref={ref} as={as} {...restProps}>
          {children}
        </StyledTypography>
      </Tooltip>

      <Falcon icon="chevron-right" $size={10}/>
    </ItemContainer>);
}
